import { FilterFormValues } from "../components/forms";
import {
  CLIENT_NAME_FILTER_SEARCH_PARAMETER,
  CLIENT_PHONE_FILTER_SEARCH_PARAMETER,
  CREATED_FROM_FILTER_SEARCH_PARAMETER,
  CREATED_TO_FILTER_SEARCH_PARAMETER,
  DELIVERY_LOCATION_FILTER_SEARCH_PARAMETER,
  DRIVER_ID_FILTER_SEARCH_PARAMETER,
  GENDER_FILTER_SEARCH_PARAMETER,
  LOCATION_ID_FILTER_SEARCH_PARAMETER,
  ORDER_TYPE_FILTER_SEARCH_PARAMETER,
  RESELLER_NAME_FILTER_SEARCH_PARAMETER,
  RESELLER_PHONE_FILTER_SEARCH_PARAMETER,
  STATUS_FILTER_SEARCH_PARAMETER,
  TOTAL_FROM_FILTER_SEARCH_PARAMETER,
  TOTAL_TO_FILTER_SEARCH_PARAMETER,
  UNPACKING_STATUS_FILTER_SEARCH_PARAMETER
} from "../constants";

export const getOrdersTableFilterNewSearchParams = ({
  gender,
  unpackingStatus,
  orderTotalFrom,
  orderTotalTo,
  deliveryZoneId,
  driverId,
  statuses,
  clientName,
  clientPhone,
  resellerName,
  resellerPhone,
  deliveryLocation,
  type,
  createdFrom,
  createdTo
}: FilterFormValues) => {
  const newSearchParams: Record<string, string | string[]> = {};
  if (gender != null) newSearchParams[GENDER_FILTER_SEARCH_PARAMETER] = gender;
  if (unpackingStatus != null)
    newSearchParams[UNPACKING_STATUS_FILTER_SEARCH_PARAMETER] = unpackingStatus;
  if (orderTotalFrom != null)
    newSearchParams[TOTAL_FROM_FILTER_SEARCH_PARAMETER] =
      String(orderTotalFrom);
  if (orderTotalTo != null)
    newSearchParams[TOTAL_TO_FILTER_SEARCH_PARAMETER] = String(orderTotalTo);
  if (deliveryZoneId != null && !!deliveryZoneId.length)
    newSearchParams[LOCATION_ID_FILTER_SEARCH_PARAMETER] =
      String(deliveryZoneId);
  if (driverId != null && !!driverId.length)
    newSearchParams[DRIVER_ID_FILTER_SEARCH_PARAMETER] = String(driverId);
  if (statuses != null)
    newSearchParams[STATUS_FILTER_SEARCH_PARAMETER] = statuses;
  if (clientName != null && !!clientName.trim().length)
    newSearchParams[CLIENT_NAME_FILTER_SEARCH_PARAMETER] = clientName;
  if (clientPhone != null && !!clientPhone.trim().length)
    newSearchParams[CLIENT_PHONE_FILTER_SEARCH_PARAMETER] = clientPhone;
  if (resellerName != null && !!resellerName.trim().length)
    newSearchParams[RESELLER_NAME_FILTER_SEARCH_PARAMETER] = resellerName;
  if (resellerPhone != null && !!resellerPhone.trim().length)
    newSearchParams[RESELLER_PHONE_FILTER_SEARCH_PARAMETER] = resellerPhone;
  if (deliveryLocation != null && !!deliveryLocation.trim().length)
    newSearchParams[DELIVERY_LOCATION_FILTER_SEARCH_PARAMETER] =
      deliveryLocation;
  if (type != null) newSearchParams[ORDER_TYPE_FILTER_SEARCH_PARAMETER] = type;
  if (createdFrom != null)
    newSearchParams[CREATED_FROM_FILTER_SEARCH_PARAMETER] = createdFrom;
  if (createdTo != null)
    newSearchParams[CREATED_TO_FILTER_SEARCH_PARAMETER] = createdTo;

  return newSearchParams;
};
